import { PERSHING_CLIENT } from 'IntegrationsApp/ts/constants';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class PershingIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getPershingIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.PERSHING_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    getPershingClientSearchResults(searchTerms, page) {
        const urlParams = { searchType: PERSHING_CLIENT };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.PERSHING_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getPershingClientAccounts(clientId, ibdId, page) {
        const urlParams = { clientId };
        const getParams = { ibdId };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.PERSHING_CLIENT_ACCOUNTS, urlParams)}?page=${page}`;
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
    importPershingHoldings(importType, postParams) {
        const urlParams = { importType };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.PERSHING_IMPORT_HOLDINGS, urlParams)}`;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
}
PershingIntegrationService.ɵfac = function PershingIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PershingIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
PershingIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PershingIntegrationService, factory: PershingIntegrationService.ɵfac, providedIn: 'root' });
